import { HostingDisplayName } from '@atlassian/mpac-types';
import { SectionHeading } from '@atlassian/mpac-ui';
import React from 'react';

var PricingHeading = function PricingHeading(_ref) {
  var hosting = _ref.hosting;
  return /*#__PURE__*/React.createElement(SectionHeading, null, HostingDisplayName[hosting], " Pricing");
};

export default PricingHeading;